var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hotel-directory" },
    [
      _c("hotel-directory-editor", {
        attrs: { user: _vm.user, "account-id": _vm.accountId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }